<template>
  <div v-if="crutch" class="custom-select custom-select-init" @click="isOpened = !isOpened">
    <select v-model="value">
      <option v-for="(val, index) in option.values" :disabled="isDisabled(option.id, val.id)" :value="val.id"
              :key="val.id" >
        <span v-html="val.name" :class="getValueClass(option, val)"></span>
      </option>
    </select>
    <div :class="{'select-selected': true, 'select-arrow-active': isOpened}">
      <span class="product__option__value active" data-font-size="16" data-font-size-type="px" v-html="selectedText"></span></div>
    <div :class="{'select-items': true, 'select-hide': !isOpened}">
      <div v-for="(val, index) in option.values" @click="setVal(val.id)"><span v-html="val.name" class="product__option__value" data-font-size="16" data-font-size-type="px" ></span></div>
    </div>
  </div>
</template>

<style>

</style>

<script>
import {computed, nextTick, onBeforeMount, onMounted, ref, watch} from "vue";

export default {
  name: "OptionSelect",
  props: {
    option: {},
    selected: {},
    isDisabled: {},
    isOpened: false,
  },
  setup(props, {emit}) {
    const value = computed({
      get: () => {
        return props.selected[props.option.id]
      },
      set: (val) => {
        emit('onChange', {option: props.option, val: props.option.values.find(i => i.id === val)})
      }
    })
    const selectedText = computed(() => {
        if(!value.value) {
          const selected = props.option.values[0];
          return selected ? selected.name : ''
        } else {
          const selected = props.option.values.find(i => i.id === value.value);
          return selected ? selected.name : ''
        }
    })

    const setVal = (val) => {
      console.log('opt',props.option.values.find(i => i.id === val))
      const selected = props.option.values.find(i => i.id === val);
      emit('onChange', {option: props.option, val: props.option.values.find(i => i.id === val)})
    }

    const crutch = ref(true)

    watch(
      () => value.value,
      () => {
        crutch.value = false;
        nextTick(() => {
          crutch.value = true
        })
      })

    const getValueClass = (option, val) => {
      return {
        'disabled': props.isDisabled(option.id, val.id),
        'product__option__value': true,
        'active': props.selected[option.id] === val.id,
      }
    }

    onBeforeMount(() => {
      for (const val of props.option.values) {
        if (!props.isDisabled(props.option.id, val.id)) {
          value.value = val.id
          return
        }
      }
    })

    onMounted(() => {
      //setVal(props.option.values[0].id)
    })

    return {
      value,
      crutch,
      selectedText,
      getValueClass,
      setVal,
    }
  }
}
</script>
